<template>
    <div v-cloak>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Nova Questão</b>

                        <i class="fa fa-list-alt" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>
            <div class="panel-body">
                <div class="row" style="margin-top:-25px;">
                    <form id="form">
                        <div class="col-md-8">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label for="description">Descrição da Questão</label>
                                    <input type="text" v-model="question.description" class="form-control"
                                           id="description">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 text-right">
                            <button type="button" class="btn btn-info" data-toggle="modal" data-target="#myModal"
                                    style="margin-top:25px;">Adicionar Resposta <i class="fa fa-plus"></i></button>
                        </div>

                        <div class="col-md-12 m-t-sm">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Pontuação</th>
                                        <th>Remover</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="question.answers.length" v-for="(answer, index) in question.answers">
                                        <td>{{ answer.description }}</td>
                                        <td>{{ answer.points }}</td>
                                        <td>
                                            <button type="button" class="btn btn-danger" @click="removeAnswer(index)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="!question.answers.length">
                                        <td colspan="3">Nenhuma resposta adicionada</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="col-md-12">
                            <div class="block text-right">
                                <router-link to="/question" class="btn btn-info">
                                    <i class="fa fa-arrow-left"></i> Voltar
                                </router-link>
                                <a class="btn btn-success" @click="save">
                                    Salvar <i class="fa fa-save"></i>
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal" id="myModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>Adicionar Resposta</h3>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="form-group">
                                <label for="answer_description">Descrição</label>
                                <input type="text" class="form-control" id="answer_description"
                                       v-model="aux.description">
                            </div>
                            <div class="form-group">
                                <label for="answer_points">Pontos</label>
                                <input type="number" class="form-control" id="answer_points" v-model="aux.points">
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModal">Cancelar <i
                                class="fa fa-remove"></i></button>
                        <button type="button" class="btn btn-success" @click="addAnswer">Adicionar <i
                                class="fa fa-plus-circle"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                question: {
                    description: '',
                    answers: []
                },
                aux: {
                    description: '',
                    points: ''
                }
            }
        },
        methods: {
            save: function () {
                const self = this;
                const api  = self.$store.state.api + 'question';

                self.$http
                    .post(api, self.question)
                    .then((response) => {
                        self.$message(null, 'Questão adicionada com sucesso', 'success');

                        self.question = {
                            description: '',
                            answers: []
                        }
                    })
                    .catch((error) => {
                        self.$error(error);
                    });
            },
            addAnswer: function () {
                this.question.answers.push(this.aux);
                this.aux = {
                    description: '',
                    points: ''
                };
                this.closeModal();
            },
            closeModal: function () {
                $('#myModal').modal('hide');
            },
            removeAnswer: function (index) {
                this.question.answers.splice(index, 1);
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Question/Add.vue